var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"notification-alert",attrs:{"value":_vm.show,"type":_vm.type,"dismissible":""},on:{"input":_vm.closeAlert}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }